import React from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import UtilFunctions from '~utils/functions';
import { ProjectAccStatusEnum } from '~utils/enums';
import * as Styles from './_confirmUpdateStatusProjectModal.module.scss';

type TConfirmUpdateStatusProjectModalProps = {
    currentStatus: ProjectAccStatusEnum;
    onClose?: () => void;
};

const ConfirmUpdateStatusProjectModal = ({ currentStatus, onClose }: TConfirmUpdateStatusProjectModalProps) => {
    const dispatch = useAppDispatch();
    const projectDetails = useAppSelector(state => state.project.projectDetails);

    const isOpen = useAppSelector(state => state.project.modals.projectStatusProjectIsOpen);

    const isLoading = useAppSelector(state => state.project.loadings.editProjectDetails);
    const error = useAppSelector(state => state.project.errors.editProjectDetails);

    const newStatus = currentStatus === ProjectAccStatusEnum.Active
        ? ProjectAccStatusEnum.Deactivated
        : ProjectAccStatusEnum.Active;

    const getStatusLabel = () => currentStatus === ProjectAccStatusEnum.Deactivated
        ? 'Activate Project'
        : 'Deactivate Project';

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        currentStatus === ProjectAccStatusEnum.Deactivated
            ? Styles['confirm-activate']
            : Styles['confirm-deactivate'],
    ]);

    const handleSubmitClick = () => {
        if (!projectDetails) return;

        const payload = {
            projectId: projectDetails.projectId,
            projectName: projectDetails.projectName,
            earmarkAmount: projectDetails.earmarkAmount,
            earmarkEndDate: projectDetails.earmarkEndDate,
            description: projectDetails.description || '',
            status: newStatus,
        };

        dispatch(combinedActions.projectEditProjectDetailsAttempt(payload));

        handleClose();
    };

    const handleClose = () => {
        dispatch(combinedActions.projectSetStatusProjectModalIsOpen(false));
        if (onClose) onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title={`Confirm ${getStatusLabel()}?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label={getStatusLabel()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                />
            </div>

            {error && <Text label={error} isError />}
        </Modal>
    );
};

export default ConfirmUpdateStatusProjectModal;
